export const civilStatuses = [
    {
        codigo: 1,
        nombre: 'Soltero'
    },
    {
        codigo: 2,
        nombre: 'Casado'
    },
    {
        codigo: 3,
        nombre: 'Viudo'
    },
    {
        codigo: 4,
        nombre: 'Divorciado'
    }
];
